/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */
import "@babel/polyfill";
import router from "./router";
import { mapGetters, mapMutations, mapActions } from "vuex";
import Mixin from "./mixins";
import Vuetify from "vuetify";
import Croppa from "vue-croppa";
import VueCurrencyFilter from "vue-currency-filter";
import VueMoment from "vue-moment";
import VueSweetalert2 from "vue-sweetalert2";
import browserDetect from "vue-browser-detect-plugin";
import MainNavigation from "@components/MainNavigation";
import MainContent from "@components/MainContent";

// import VvAutocomplete from '@components/extended/VvAutocomplete';
// Vue.component('vv-autocomplete', VvAutocomplete);

require("spark-bootstrap");
require("./spark-components/bootstrap");
require("./bootstrap");

const store = require("./store");
/**
 * Initialize Vuetify Theme
 */

Vue.use(Vuetify, {
	customProperties: true,
	theme: store.state.theme,
	icons: {
		clear: {
			component: "fa-icon",
			props: {
				icon: ["fal", "times"]
			}
		}
	}
});

// Use colors from db in css
let root = document.documentElement;
_.forEach(store.state.theme, (color, key) => {
	root.style.setProperty(`--color-${key}`, color);
});

/**
 * Initialize Croppa Image Cropper
 */
Vue.use(Croppa, {
	componentName: "image-cropper"
});

/**
 * Initialize Moment Filter
 */
Vue.use(VueMoment);

/**
 * Initialize Currenct Filter
 */
Vue.use(VueCurrencyFilter, {
	symbol: "$",
	thousandsSeparator: ",",
	fractionCount: 2,
	fractionSeparator: ".",
	symbolPosition: "front",
	symbolSpacing: false
});

/**
 * Initialize Currency Filter
 */
Vue.use(VueSweetalert2, {
	confirmButtonColor: store.state.theme.success,
	cancelButtonColor: "#C1C5C8",
	target: ".application"
});

/**
 * Initialize Browser Detect
 */
Vue.use(browserDetect);

Vue.mixin(Mixin);
Vue.config.productionTip = false;

var app = new Vue({
	data: {
		showPassword: false,
		showNewPassword: false,
		showNewPasswordConfirmation: false,
		alerts: []
	},
	computed: {
		...mapGetters(["dark", "fluid"]),

		colors() {
			return this.$vuetify.theme;
		}
	},
	methods: {
		...mapMutations(["PUSH_ITEM", "ADD_NOTIFICATION"]),

		...mapActions("messages", {
			CHANGE_STATUS: "changeStatus"
		}),

		displayAlerts() {
			let alert = _.head(this.alerts);

			if (alert) {
				this.$swal({
					title: alert.subject,
					text: alert.body,
					type: "warning",
					showCancelButton: false,
					allowOutsideClick: false,
					allowEscapeKey: false,
					confirmButtonText: "OK Got It!"
				}).then(result => {
					this.CHANGE_STATUS({
						id: alert.id,
						status: "read"
					});

					this.popFirstAlert();
					this.displayAlerts();
				});
			}
		},

		popFirstAlert() {
			this.alerts.splice(0, 1);
		},

		pushAlert(alert) {
			this.alerts.push(alert);

			this.displayAlerts();
		}

		// markAlartAsRead(alert) {
		// 	his.CHANGE_STATUS({
		// 		id: alert.id,
		// 		status: 'read',
		// 	});
		// },
	},
	components: {
		MainNavigation,
		MainContent
	},
	mixins: [require("spark")],
	store,
	router,

	created() {
		if (Spark.userId) {
			// Echo.private(`user.${Spark.userId}`)
			// 	.listen(".new.message", ({ message }) => {
			// 		let date = Date.now();
			//
			// 		this.PUSH_ITEM({
			// 			name: "messages.messages",
			// 			value: message
			// 		});
			//
			// 		this.ADD_NOTIFICATION({
			// 			show: true,
			// 			type: "success",
			// 			text: `${message.from.name} has sent you a message.`,
			// 			id: `message-${message.id}-received-${date}`,
			// 			direction: "received",
			// 			message: message
			// 		});
			// 	})
			// 	.listen(".new.alert", ({ message }) => {
			// 		// this.PUSH_ITEM({
			// 		// 	name: 'messages.messages',
			// 		// 	value: message,
			// 		// });
			//
			// 		this.pushAlert(message);
			// 	});
		}

		this.$set(
			this,
			"alerts",
			this.getObjectValue("Spark.alerts", window, [])
		);
	},

	mounted() {
		const supportedBrowsers =
			this.$browserDetect.isChrome ||
			this.$browserDetect.meta.name === "Chrome" ||
			this.$browserDetect.meta.name === "Safari" ||
			this.$browserDetect.isFirefox ||
			this.$browserDetect.isEdge ||
			this.$browserDetect.isSafari;

		// console.log(this.$browserDetect.meta.name);

		if (!supportedBrowsers) {
			this.$swal({
				title: "Your browser is not supported!",
				text:
					"Please download and/or use one of the supported browsers from the list below.",
				type: "error",
				width: "800px",
				showCancelButton: false,
				allowOutsideClick: false,
				allowEscapeKey: false,
				showConfirmButton: false,
				onBeforeOpen: () => {
					new Vue({
						el: ".browser-support"
					});
				},
				html: `<p>Please download one of the supported browsers from the list below.</p>
				<div class="browser-support">
					<div class="browser-support__browser">
						<div class="browser-support__icon">
							<fa-icon :icon="['fab', 'chrome']" size="4x"></fa-icon>
							<br />
							Chrome
						</div>
						<v-btn color="primary" href="http://www.chrome.com/" target="_blank">Download</v-btn>
					</div>
					<div class="browser-support__browser">
						<div class="browser-support__icon">
							<fa-icon :icon="['fab', 'firefox']" size="4x"></fa-icon>
							<br />
							Firefox
						</div>
						<v-btn color="primary" href="http://www.firefox.com/" target="_blank">Download</v-btn>
					</div>
					<div class="browser-support__browser">
						<div class="browser-support__icon">
							<fa-icon :icon="['fab', 'edge']" size="4x"></fa-icon>
							<br />
							Edge
						</div>
						<v-btn color="primary" href="https://www.microsoft.com/en-us/windows/microsoft-edge" target="_blank">Learn More</v-btn>
						<span>(Windows Only)</span>
					</div>
					<div class="browser-support__browser">
						<div class="browser-support__icon">
							<fa-icon :icon="['fab', 'safari']" size="4x"></fa-icon>
							<br />
							Safari
						</div>
						<v-btn color="primary" href="https://www.apple.com/safari/" target="_blank">Learn More</v-btn>
						<span>(Mac Only)</span>
					</div>
				</div>`
			});
		}

		this.displayAlerts();
	}
});

Vue.filter("phone", function(phone) {
	if (typeof phone !== "string") {
		return phone;
	}

	return phone
		.replace(/[^0-9]/g, "")
		.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
});
